/**
 *  学习目标：组件拆分
 */
import React from 'react';
import './styles/base.css';
import './styles/index.css';

export default function App(params) {
  return (
    <h1>演示-CICD 自动化部署 -看看我是谁</h1>
  );
}
